// The unauthenticated screens carry no navbar, so both halves of the split own
// the whole viewport: the brand panel is pinned to exactly that, the form
// column may grow past it.
export const AUTH_PANEL_HEIGHT = "lg:h-screen";
export const AUTH_COLUMN_MIN_HEIGHT = "min-h-screen";

// Shared look for every control on the unauthenticated screens, so the input,
// select and checkbox never drift apart.
export const LABEL_CLASS = "mb-1.5 block text-sm font-semibold text-gray-800";

export const ERROR_CLASS = "mt-1.5 text-xs text-danger-500";

export const controlClass = (hasError) =>
  `w-full rounded-lg border bg-white px-3.5 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 transition focus:outline-none focus:ring-2 ${
    hasError
      ? "border-danger-400 focus:border-danger-400 focus:ring-danger-100"
      : "border-gray-200 hover:border-gray-300 focus:border-brand-500 focus:ring-brand-100"
  }`;
